import React from "react"
import styles from "./Skeleton.module.scss"
import cn from "classnames"

interface SkeletonProps {
    className?: string
}

const Skeleton: React.FC<SkeletonProps> = (props: SkeletonProps) => {
    return <div className={cn(styles.container__skeleton, props.className)} role="status" />
}

export default Skeleton
